import React, { useEffect } from "react";

import { QuestionOpen } from "../questionOpen/questionOpen.component";
import { Choice } from "../questionChoice/questionChoice.component";

export const Question = ({ question, setAnswer, section, submitted, validatedQuestions, setValidatedQuestions }) => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const parseRegex = (regexString) => {
    const matches = regexString.match(/^\/(.*)\/([a-z]*)$/);
    if (matches) {
      return new RegExp(matches[1], matches[2]);
    }

    return new RegExp(regexString);
  }

  const isAnswerValid = (value) => {
    const { pattern } = question.answers[0];

    if (pattern.length > 0) {
      return parseRegex(pattern).test(String(value).toUpperCase());
    } else if (question.required) {
      return (value.length > 2 && value.length < 128);
    }

    return true;
  };

  useEffect(() => {
    const selectedAnswers = question.answers.filter(answer => answer.selected)
    if (!validatedQuestions.includes(question.id)) {
      if (question.type === 'open' && !isAnswerValid(question.answers[0].answer)) {
        return;
      } else if (['single_choice', 'multiple_choice'].includes(question.type) && selectedAnswers.length === 0) {
        return;
      }

      setValidatedQuestions([...validatedQuestions, question.id])
    }
  }, [validatedQuestions, question]);

  const boundSetAnswer = ({ target }) => {
    setAnswer(question.answers[0].id, target.value);
    if (!validatedQuestions.includes(question.id) && isAnswerValid(target.value)) {
      setValidatedQuestions([...validatedQuestions, question.id])
    } else if (validatedQuestions.includes(question.id) && !isAnswerValid(target.value)) {
      setValidatedQuestions(validatedQuestions.filter(id => id !== question.id))
    }
  };

  const setChecked = (selectedAnswers) => {
    if (selectedAnswers === 0) {
      setValidatedQuestions(validatedQuestions.filter(id => id !== question.id))
    } else if (!validatedQuestions.includes(question.id)) {
      setValidatedQuestions([...validatedQuestions, question.id])
    }
  };

  switch (question.type) {
  case "open":
    return (
      <QuestionOpen
        question={question}
        setAnswer={boundSetAnswer}
        error={submitted ? !isAnswerValid(question.answers[0].answer) : false}
      />
    );
  case "single_choice":
    return (
      <Choice
        title={question.question}
        answers={question.answers}
        setAnswer={setAnswer}
        section={section}
        setChecked={setChecked}
        error={submitted ? !validatedQuestions.includes(question.id) : false}
      />
    );
  case "multiple_choice":
    return (
      <Choice
        setChecked={setChecked}
        title={question.question}
        answers={question.answers}
        setAnswer={setAnswer}
        multi={true}
        section={section}
        error={submitted ? !validatedQuestions.includes(question.id) : false}
      />
    );
  case "open_choice":
    return null;
  default:
    return <div>{question.type}</div>;
  }
};
